/* eslint-disable */
// @ts-nocheck

import { ExtensionConfig, SimpleXdmExtension } from './SimpleXdmExtension';

/**
 * This interface identifies a minimal abstraction of the Connect host object as required by this
 * library.
 */
export interface ConnectHost {
	onIframeEstablished(callback: Function): void;

	offIframeEstablished(callback: Function): void;

	onIframeUnload(callback: Function): void;

	offIframeUnload(callback: Function): void;

	createExtension(extensionConfig: ExtensionConfig): SimpleXdmExtension;

	destroy(extension_id: string): void;

	getContentResolver(): Function;

	isJwtExpired(jwtString: string): boolean;

	hasJwt(url: string): boolean;
}
